import { createSlice } from "@reduxjs/toolkit";
import getList from "../Actions/GetNewReqList-Action";
const initialState = {
  reqList: [],
  isLoading: false,
  status: "",
  isLoaded: false,
  lastEvaluatedkey: "",
  loadMore: false,
};
const RestaurantReqList = createSlice({
  name: "RestaurantReqList",
  initialState,
  reducers: {
    getRestaurant(state, action) {
      state.reqList = state.reqList.concat(action.payload);
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    changeStatus(state, action) {
      return { ...state, reqList: action.payload, isLoaded: true };
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setReqList(state, action) {
      state.reqList = action.payload;
    },
    setIsLoaded(state, action) {
      state.isLoaded = action.payload;
    },
  },
  extraReducers: {
    [getList.pending]: (state, action) => {
      if (state.lastEvaluatedkey === "") {
        state.isLoading = true;
      } else {
        state.loadMore = true;
      }
    },
    [getList.fulfilled]: (state, action) => {
      if (action.payload.status_code === 200) {
        let currentArr = state.reqList;
        let newArr = [];
        newArr = action.payload.Maindata;
        state.reqList = state.reqList.concat(newArr);
        state.lastEvaluatedkey = action.payload.lastEvaluatedkey
          ? action.payload.lastEvaluatedkey
          : "";
      } else {
        state.status = "Something went wrong😥";
      }
      state.isLoading = false;
      state.loadMore = false;
    },
    [getList.rejected]: (state, action) => {
      state.isLoading = false;
      state.loadMore = false;
      state.status = action.error.message;
    },
  },
});

export const ReqListActions = RestaurantReqList.actions;

export default RestaurantReqList.reducer;
